<template>
  <div>
    <HeaderSistema :title="title" :subtitle="subtitle" class="header__sistema" v-if="displayNone" />
    <BreadSistema class="bread__sistema" v-if="displayNone" />
    <router-view @update-header="updateHeader"></router-view>
  </div>
</template>

<script>
export default {
  components: {
    HeaderSistema: () => import('@/components/GlobalComponents/jumbotron-header'),
    BreadSistema: () => import('@/components/GlobalComponents/bread-sistema.vue'),
  },
  data() {
    return {
      title: '',
      subtitle: '',
    };
  },
  computed: {
    displayNone() {
      return (
        this.$route.name !== 'render-conteudo-exclusivo' &&
        this.$route.name !== 'thanks' &&
        this.$route.name !== 'professionalCurriculum' &&
        this.$route.name !== 'atendimentoDigital' &&
        this.$route.name !== "maintenanceExclusivo"
      )
    }
  },
  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },

  methods: {
    updateHeader(headerData) {
      this.title = headerData.title;
      this.subtitle = headerData.subtitle;
    },
  },
};
</script>